import React from "react";
import Like from "./Like";
import WriteComment from "./WriteComment";
import classnames from 'classnames';
import styles from "./CommentItem.modules.less";
import { replaceUrlWithAnchor } from "@Lib/common";

export interface IProps {
  data:Object;
  response?:() => void
}

interface Istate {
  isReplyComment: boolean;

}

class CommentItem extends React.PureComponent<IProps,Istate> {
  public readonly state = {
    isReplyComment:false
  }
  isReply = (res?:any)=> {
    const {  response }:any = this.props;
    const { isReplyComment } = this.state;

    this.setState({
      isReplyComment:isReplyComment?false:true
    })

    if(res && res.status === 'ok'  ) {
      response();

    }
  }
  public render() {
    const { isReplyComment } = this.state;
    const { data  }:any = this.props;

    let isTextarea = classnames({
      'textarea-show-item':isReplyComment,
      'textarea-item':!isReplyComment
    });

    return (
      <section className={styles["IframeCommentItem"]}>
            <div className={styles['avatar']}>
                <img src={ data.member.m_headpic_new } alt=""/>
            </div>
            <div className={styles['message']}>
              <div className={styles['user-name']}>
              { data.m_name }
              <time>{ data.add_time }</time>
              </div>
              <div className={styles['comment-content']} dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data.content) }} />
              { data.reply.content &&
              <div className={styles['reply-comment']}>
                <div className={styles['reply-name']}>{ data.reply.m_name }</div>
                <div className={styles['reply-content']} dangerouslySetInnerHTML={{ __html: replaceUrlWithAnchor(data.reply.content) }} />
              </div>
              }
              <div className={styles['footer']}>
                  <div className={styles['replay-comment-btn']} onClick={() => this.isReply()}>
                    { isReplyComment?'收起':'回覆'}
                  </div>
                  <Like
                    likeCount = { data.like_num }
                    id={ data.id }
                    apiUrl="/article/comment/like"
                    lsName="articleLikeComments"
                  />
                  <div className={styles[isTextarea]}>
                    <WriteComment
                      size="small"
                      type={data.type}
                      id={data.article_id}
                      re_id={data.id}
                      re_mid={data.m_id}
                      response = { (res)=>this.isReply(res) }
                    />
                  </div>
              </div>
            </div>
      </section>
    );
  }
}

export default CommentItem;
